<template>
  <div class="user_body">
    <div class="mbx">
      <img src="@/assets/icon_home_dd.png">
      <span>首页 > 商城> 产品详情</span>
    </div>
    <div class="div_content">
      <Category/>
     
      <div class="div_right" v-if="categoryDetail">
        <div class="product_info">
          <span class="title">{{categoryDetail.title}}</span>
          <div class="bottom-info">
            <img class="img" :src="categoryDetail.thumb">

          
            <div class="xb">
              <span>{{categoryDetail.sdesc}}</span>
            </div>
          </div>
        </div>
        <div style="width: 100%; margin-top: 20px">
          <el-table
            :data="tableData"
            :span-method="objectSpanMethod"
            border
            :header-cell-style="tableHeaderStyle"
          
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column prop="name" label="产品名称" align="center" min-width="300" >
              <template slot-scope="scope">
                <span class="name_link" @click="toDetail(scope.row)">{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="huohao" label="货号" align="center" min-width="150">
              <template slot-scope="scope">
                <span class="name_link" @click="toDetail(scope.row,scope.row.id)">{{scope.row.huohao}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sku_name" label="规格" align="center" min-width="150">
              <template slot-scope="scope">
                <span>{{decodeHtmlEntities(scope.row.sku_name || '--')}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格（元）" align="center"></el-table-column>
            <el-table-column prop="number" label="数量" align="center" width="150">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.number"
                  @change="handleChange(scope.row)"
                  :min="0"
                  :max="scope.row.stock"
                  label="描述文字"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="amount4" label="订购" align="center" width="70">
              <template slot-scope="scope">
                <img src="@/assets/icon_car_dd.png" class="car_icon" @click="buyProduct(scope.row)">
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import Category from '@/components/Category.vue'
export default {
  name: "CellsLine",
  components: {
    Category
  },
  data() {
    return {

      categoryDetail:null,
      spec:[],
      skuData:[],
      tableData: [],
      firstSpecName:'',
      secondSpecName:'',
      lastSpecName:[],
      cateid:null
    };
  },
  computed: {
    ...mapGetters(['base']),
   
  },
  watch: {
    '$route.query.cateid': {
      handler(newVal) {
          if(newVal){
            this.cateid = newVal
            // this.id = newVal
            this.getDetail()
            // this.getSpec()
          }
      },
      immediate: true
    },
   
  },
  beforeMount() {
    // this.id = this.$route.params.id
    this.cateid = this.$route.query.cateid
    console.log("this.cateid is",this.cateid)
    // this.getDetail()
  },
  mounted() {},
  methods: {
    ...mapActions(['getUser']),
    async getDetail(){
      try{
        const res = await this.$api.getGoodsList({id:this.cateid})
        if(res.code==1){
          this.categoryDetail = res.data.category
          this.tableData = res.data.list.map(item=>{
            return {
              goods_id:item.goods_id,
              id: item.id,
              name: item.title,
              stock: item.stock || 0,
              huohao: item.huohao || '',
              price: item.price || 0,
              sku_name: item.sku_name || '',
              number: 1,
            }
          })
        }else{
          this.$message.error(res.msg||res.message||"获取详情失败")
        }
      }catch(err){
        console.log("err is",err)
        this.$message.error(err.message||err.msg)
      }
    },
    
    decodeHtmlEntities(text) {
      if (!text || typeof text !== 'string') return text || '--';
      
      // 创建一个临时的 textarea 元素来解码 HTML 实体
      const txt = document.createElement('textarea');
      txt.innerHTML = text;
      let decoded = txt.value;
      
      // 处理双重编码的情况（如 &amp;lt; 需要再次解码）
      // 如果解码后的文本仍然包含 HTML 实体，继续解码（最多3次，避免无限循环）
      let prevDecoded = text;
      let decodeCount = 0;
      while (decoded !== prevDecoded && decodeCount < 3) {
        prevDecoded = decoded;
        txt.innerHTML = decoded;
        decoded = txt.value;
        decodeCount++;
      }
      
      return decoded;
    },
    toDetail(item,sku){
      this.$router.push({ path: "/buyproduct/"+item.goods_id+"?number="+item.number+(sku?"&sku_id="+sku:"") });
    },
    buyProduct(item) {
      console.log("item is",item)
      this.addCart(item)
      
    },
    addCart(item){
      if(item.stock <= 0 || item.stock < item.number){
					return this.$message.error("库存不足");
				}
      this.$api.addCart({goods_id:item.goods_id,sku_id:item.id,total:item.number}).then(res => {
        if(res.code == 1){  
          this.$message.success("加入购物车成功");
          this.getDetail()
          this.getUser()
        }else{
          this.$message.error(res.message);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 设置表头的颜色
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      return "background-color: #3C9C8F26; color:#3C9C8F;"; //
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const data = this.tableData;
        const currentName = row.name;

        // 如果上一行的产品名称和当前行相同，当前行单元格就隐藏（被上面那行合并）
        if (rowIndex > 0 && data[rowIndex - 1].name === currentName) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        // 否则，从当前行开始往下统计有多少行名称相同，用于合并行数
        let rowspan = 1;
        let nextIndex = rowIndex + 1;
        while (nextIndex < data.length && data[nextIndex].name === currentName) {
          rowspan++;
          nextIndex++;
        }

        return {
          rowspan,
          colspan: 1
        };
      }
    },
    
    handleChange(row) {
      console.log("row is",row)
    }
  }
};
</script> 

<style lang="less"  scoped>
.user_body {
  box-sizing: border-box;
  margin-top: 91px;
  background: #ffffff;
  padding-left: 15%;
  padding-right: 15%;
  padding-bottom: 20px;
}
.mbx {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0;
  background: #ffffff;
}
.mbx img {
  width: 14.53px;
  height: 13.46px;
}
.mbx span {
  color: rgba(136, 136, 136, 1);
  font-size: 12px;
}
.div_content {
  display: flex;
  flex-direction: row;
  position: relative;
}

.div_right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-left: 200px;
}
.product_info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.title {
    color: rgba(51, 51, 51, 1);
  font-size: 28px;
  line-height: 42px;
  font-weight: 700;
  margin-right: 10px;
  text-align: left;
}
// .product_info img {
//   width: 228px;
//   height: 228px;
//   padding: 10px 14px 0 0;
// }
.bottom-info {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  gap: 10px;
  .img {
    width: 228px;
    height: 152px;
    aspect-ratio: 3/2;
    // border-radius: 10px;
    object-fit: cover;
  }
}
.xb {
  display: flex;
  flex-direction: column;
}

.xb span{
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  line-height: 32px;
  margin-top: -8px;
  margin-right: 20px;
}
.car_icon {
  cursor: pointer;
  width: 28px;
  height: 28px;
}
:deep(.el-input-number){
  width: 110px !important;
}
</style>
<style>
.el-input-number {
  position: relative;
  display: inline-block;
  width: 90px !important;
  line-height: 28px !important;
}
.el-input-number__decrease {
  left: 1px;
  border-radius: 4px 0 0 4px;
  border-right: 1px solid #dcdfe6;
}
.el-input-number__decrease,
.el-input-number__increase {
  position: absolute;
  z-index: 1;
  top: 1px;
  width: 30px !important;
  height: auto;
  text-align: center;
  background: #ffffff !important;
  color: #606266;
  cursor: pointer;
  font-size: 13px;
}
.el-input-number .el-input__inner {
  -webkit-appearance: none;
  padding-left: 1px !important;
  padding-right: 1px !important;
  text-align: center;
}
.el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 1px !important;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 30px !important;
  line-height: 30px !important;
  outline: 0;
  padding: 0 5px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.name_link{
  cursor: pointer;
}
</style>

 

